import { render } from "./RunmaxPerfTestPcReport.vue?vue&type=template&id=706ebd08&scoped=true"
import script from "./RunmaxPerfTestPcReport.vue?vue&type=script&lang=js"
export * from "./RunmaxPerfTestPcReport.vue?vue&type=script&lang=js"

import "./RunmaxPerfTestPcReport.vue?vue&type=style&index=0&id=706ebd08&scoped=true&lang=css"
import "./RunmaxPerfTestPcReport.vue?vue&type=style&index=1&id=706ebd08&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706ebd08"]])

export default __exports__